import angular from 'angular';
import { mapBudgetKpi } from '@/modules/relations/budgets/budgetHelpers';
import AuthService from '@/shared/services/AuthService';

angular
  .module('cxRelations')
  .factory('relBudgetSvc', ['$http', 'appUrls', '$q', 'authService', 'dataCache', relBudgetSvc]);
function relBudgetSvc($http, appUrls, $q, authService, dataCache) {
  const cache = {}; //Budget info by relationId

  const retrieveBudget = (relationId, invoiceStreamId = null) => {
    return $http
      .get(`${appUrls.api}/api/budget/relationKpi/${relationId}`, { params: { invoiceStreamId } })
      .then(
        function({ data }) {
          return mapBudgetKpi(data);
        },
        function(error) {
          console.error(error);
          return null;
        },
      );
  };
  const reload = relationId => {
    if (!relationId) return $q.when(null);
    if (!dataCache.getArray('budgetsEnabled')) return $q.when(null);
    if (
      !AuthService.hasPermission({
        functionality: 'BudgetHours',
        privilege: 'Read',
      }) &&
      !AuthService.hasPermission({
        functionality: 'BudgetAmounts',
        privilege: 'Read',
      })
    )
      return $q.when(null);
    if (!cache[relationId]) cache[relationId] = { data: null };
    return retrieveBudget(relationId).then(data => {
      cache[relationId].data = data;
      return cache[relationId];
    });
  };

  const getBudgetInfo = (relationId, forceRefresh = false) => {
    if (!relationId) return $q.when(null);
    if (!forceRefresh && typeof cache[relationId] !== 'undefined')
      return $q.when(cache[relationId]);

    return reload(relationId);
  };

  const clearCache = () => {
    for (var key in cache) if (cache.hasOwnProperty(key)) delete cache[key];
  };

  authService.addOnLogOut(function() {
    clearCache();
  });

  return {
    retrieveBudget,
    getBudgetInfo,
    reload,
    showBudgetInfo: relationId => {
      if (!relationId) return false;
      if (
        !AuthService.hasPermission({
          functionality: 'BudgetHours',
          privilege: 'Read',
        }) &&
        !AuthService.hasPermission({
          functionality: 'BudgetAmounts',
          privilege: 'Read',
        })
      )
        return false;
      if (typeof cache[relationId] === 'undefined') return true; //Give the control the chance to retrieve data
      if (!cache[relationId]) return false;
      return !!cache[relationId].data;
    },
  };
}
